import $api from "..";
import { AxiosResponse } from "axios";
import type { IUserMonitorGetTasksRequest } from "../common/api_interfaces/monitor/IUserMonitorGetTasksRequest";
import type { IUserMonitorTaskFullInfo } from "../common/api_interfaces/monitor/IUserMonitorTaskFullInfo";
import type { IFavouriteTasks } from "../common/api_interfaces/monitor/IFavouriteTasks";

export default class UserMonitorService {

    async getFavouriteTasks(): Promise<AxiosResponse<IFavouriteTasks>> {
        return $api.get<IFavouriteTasks>('/Monitor/favourite');
    }

    async setFavouriteTasks(body: any): Promise<AxiosResponse<IFavouriteTasks>> {
        return $api.post<IFavouriteTasks>(`/Monitor/favourite`, body);
    }

    async getTasks(body: IUserMonitorGetTasksRequest): Promise<AxiosResponse<IUserMonitorTaskFullInfo>> {
        return $api.post<IUserMonitorTaskFullInfo>(`/Monitor/getTasks`, body);
    }

}